module.exports = __webpack_public_path__ + "static/317939799_666027215193717_513834572527467737_n.jpg-1671186393237_1024-36840b7064e335e2dac38a645b68775a.webp";